import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
// import { BezierPlugin } from 'gsap/BezierPlugin';
import './FlowerLoader.css'; // You can add your CSS styles here

// gsap.registerPlugin(BezierPlugin); // Register the BezierPlugin correctly

const FlowerLoader = () => {
  const flowerRef = useRef(null);
  const leavesRef = useRef(null);
  const centerRef = useRef(null);
  const numberOfLeaves = 7;
  const rotation = 360 / numberOfLeaves;

  const LEAF_SVG = `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.7 51.8" style="enable-background:new 0 0 23.7 51.8;" xml:space="preserve">
      <path d="M11.8,0c0,0-26.6,24.1,0,51.8C38.5,24.1,11.8,0,11.8,0z"/>
    </svg>
  `;

  useEffect(() => {
    const path = [
      { x: 15, y: 0 },
      { x: 16, y: -1 },
      { x: 17, y: 0 },
      { x: 16, y: 1 },
      { x: 15, y: 0 }
    ];

    const location = { x: path[0].x, y: path[0].y };
    const tween = gsap.to(location, {
      bezier: {
        curviness: 1.5,
        values: path,
      },
      ease: 'none',
      duration: numberOfLeaves,
    });

    const addLeaves = () => {
      const leavesContainer = leavesRef.current;

      for (let i = 0; i < numberOfLeaves; i++) {
        const leafElement = document.createElement('div');
        leafElement.className = 'flower__leaf';
        leafElement.innerHTML = `<div class="flower__leaf-inner">${LEAF_SVG}</div>`;
        tween.time(i);

        gsap.set(leafElement, {
          x: location.x - 11,
          y: location.y - 37,
          rotation: rotation * i - 90,
        });

        leavesContainer.appendChild(leafElement);
      }

      animateLeaves();
    };

    const animateLeaves = () => {
      const leaves = leavesRef.current.querySelectorAll('.flower__leaf-inner');
      const center = centerRef.current;

      const timeline = gsap.timeline({
        onComplete: () => timeline.restart(true),
      });

      timeline
        .add(
          gsap.fromTo(center, { scale: 0 }, { scale: 1, ease: 'elastic.out(1.1, 0.75)', duration: 1 }),
          0
        )
        .add(
          gsap.to(leaves, { scale: 1, stagger: 0.2, ease: 'elastic.out(1.1, 0.75)', duration: 1 }),
          0.3
        )
        .add(gsap.to(leaves, { scale: 1.25, ease: 'elastic.out(1.5, 1)', duration: 0.3 }))
        .add(
          gsap.to(leavesRef.current, { rotation: 360, ease: 'expo.inOut', duration: 1.5 }),
          1.7
        )
        .add(gsap.to(leaves, { scale: 0, ease: 'elastic.inOut(1.1, 0.75)', duration: 0.5 }))
        .add(gsap.to(center, { scale: 0, ease: 'elastic.inOut(1.1, 0.75)', duration: 0.5 }), '-=0.37');
    };

    addLeaves();
  }, []);

  return (
    <div className="flower" ref={flowerRef}>
      <div className="flower__center" ref={centerRef}></div>
      <div className="flower__leaves" ref={leavesRef}></div>
    </div>
  );
};

export default FlowerLoader;
